// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mqatP","col":"styles_col__3JNTm"};